import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators/custom-element.js';
import styles from './rhpt-trial-row-info.css';

/**
 * Trial Row
 * @slot - Place element content here
 */
@customElement('rhpt-trial-row-info')
export class RhptTrialRowInfo extends LitElement {
  static readonly styles = [styles];

  render() {
    return html`
      <rh-dialog>
        <slot name="pfe-modal--header" slot="header"></slot>
        <slot></slot>
        <span id="dialogFocusTrapStart" tabindex="-1" class="visually-hidden">Dialog start</span>
      </rh-dialog>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rhpt-trial-row-listing': RhptTrialRowInfo;
  }
}
